import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  Table,
  Typography,
  Tag,
  Select,
  Row,
  Col,
  Button,
  Rate,
  message,
} from "antd";
import { StarOutlined, SearchOutlined, SyncOutlined } from "@ant-design/icons";
import AdvancedSearchForm from "../../../common/SearchForm";
import FeedbackDetailDrawerModal from "./components/feedbackDetailDrawerModal";
import styles from "../../../common/Layout.module.scss";
import LikeIcon from "../../../assets/like.svg";
import DislikeIcon from "../../../assets/dislike.svg";

const { Title, Link } = Typography;
const { Option } = Select;
function Feedback(props) {
  const atmedPaymentsRefresh = useSelector(
    (state) => state.vendorEquipmenReducer.allEquipmentFeedbackAll
  );

  const [descriptionModal, setDescriptionModal] = useState(false);
  const [currentColumn, setCurrentColumn] = useState([]);
  const [searchOption, setSearchOption] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const renderData = useCallback(
    (currentPage) => {
      props.getAtmedEquipmentFeedBack(undefined, 20, currentPage);
    },
    [props.getAtmedEquipmentFeedBack]
  );

  useEffect(() => {
    renderData(currentPage);
  }, [renderData, currentPage]);

  const handleRefresh = () => {
    props.getAtmedEquipmentFeedBack(undefined, 20, currentPage);
    if (atmedPaymentsRefresh && atmedPaymentsRefresh) {
      message.success(atmedPaymentsRefresh.message);
    }
  };

  const columns = [
    {
      title: "Order ID",
      key: "order_id",
      dataIndex: "order_id",
      width: "20%",
      render: (_, columnData) => (
        <Row className="name-details-row">
          <Col offset={1}>
            <div className="table-fc-name">{columnData.product_name}</div>
            <div className="table-fc-email">Order ID: {columnData.orderid}</div>
            <div className="table-fc-email">Date: {columnData.order_date}</div>
            <div className="view-details">
              <Link
                onClick={() => {
                  setDescriptionModal(true);
                  setCurrentColumn(columnData);
                }}
              >
                VIEW DETAILS
              </Link>
            </div>
          </Col>
        </Row>
      ),
    },
    {
      title: "Vendor Name",
      key: "vendor_name",
      dataIndex: "vendor_name",
    },
    {
      title: "Customer Name",
      key: "patient_name",
      render: (_, columnData) => (
        <Row>
          <Col span={24}>{columnData.patient_name} </Col>
          <Col span={24} className="lightFont">
            {columnData.patient_phone}
          </Col>
        </Row>
      ),
    },
    {
      title: "Reviews",
      key: "review",
      width: "29%",
      render: (_, columnData) => (
        <div>
          <div className="content f-Size-13px">{`${columnData.review}`}</div>
          {columnData.rating >= 4 ? (
            <>
              {columnData.product_quality > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img
                    src={LikeIcon}
                    alt="Product Quality"
                    className="thumbs-up"
                  />
                  Product Quality
                </Tag>
              ) : (
                ""
              )}
              {columnData.delivery_time > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img
                    src={LikeIcon}
                    alt="Delivery Time"
                    className="thumbs-up"
                  />
                  Delivery Time
                </Tag>
              ) : (
                ""
              )}
              {columnData.customer_service > 0 ? (
                <Tag color="success" className={styles.feedbackReviewStyle}>
                  <img
                    src={LikeIcon}
                    alt="Customer Service"
                    className="thumbs-up"
                  />
                  Customer Service
                </Tag>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {columnData.product_quality > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Product Quality" />
                  Product Quality{" "}
                </Tag>
              ) : (
                ""
              )}
              {columnData.delivery_time > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Delivery Time" />
                  Delivery Time
                </Tag>
              ) : (
                ""
              )}
              {columnData.customer_service > 0 ? (
                <Tag color="error" className={styles.feedbackReviewStyle}>
                  <img src={DislikeIcon} alt="Customer Service" />
                  Customer Service
                </Tag>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      ),
    },
    {
      title: "Ratings",
      key: "rating",
      render: (_, columnData) => <Rate disabled value={columnData.rating} />,
    },
  ];
  const onSearch = (values) => {
    const newValues = JSON.parse(JSON.stringify(values));
    const queryString = Object.keys(newValues)
      .map((key) => `${key}=${newValues[key]}`)
      .join("&");
    props.getAtmedEquipmentFeedBack(queryString, 20, currentPage);
  };

  const toggleSearch = () => {
    setSearchOption(!searchOption);
  };

  return (
    <div>
      <FeedbackDetailDrawerModal
        data={currentColumn}
        visible={descriptionModal}
        onCancel={() => setDescriptionModal(false)}
      />
      <Row gutter={[0, 16]}>
        <Col className="gutter-row section-heading" span={13} offset={0}>
          <Title
            level={2}
            className="d-flex"
            style={{ justifyContent: "space-between", alignItems: "right" }}
          >
            Feedback / Ratings - Medical Equipment
          </Title>
        </Col>
        <Col className="gutter-row " justify="end" span={2} offset={7}>
          <Button
            className={`${
              searchOption === true ? "search-open" : "search-close"
            } search-toggle-button`}
            onClick={() => toggleSearch()}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col
          className="gutter-row header-buttons"
          justify="end"
          span={1}
          offset={1}
        >
          <Button
            shape="circle"
            icon={<SyncOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => handleRefresh()}
          />
        </Col>
      </Row>
      {searchOption === true ? (
        <AdvancedSearchForm
          onSearch={onSearch}
          onClose={() => setSearchOption(false)}
          title="Health Products"
          columnWidth={{
            xs: 24,
            md: 12,
            lg: 8,
          }}
          formItems={[
            {
              key: "q[equip_order_orderid_cont]",
              label: "Order ID",
            },
            {
              key: "q[equip_vendor_name_cont]",
              label: "Vendor Name",
            },
            {
              key: "q[equip_order_product_name_cont]",
              label: "Product Name",
            },
            {
              key: "q[patient_name_cont]",
              label: "Customer Name",
            },
            {
              key: "q[rating_eq]",
              label: "Ratings",
              Component: (
                <Select placeholder="Select Star Rating" size="large">
                  <Option value="5">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="4">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="3">
                    <StarOutlined />
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="2">
                    <StarOutlined />
                    <StarOutlined />
                  </Option>
                  <Option value="1">
                    <StarOutlined />
                  </Option>
                </Select>
              ),
            },
          ]}
        />
      ) : (
        ""
      )}
      <Table
        className="list_table"
        dataSource={
          props.allEquipmentFeedback ? props.allEquipmentFeedback.data : null
        }
        pagination={{
          pageSize: 20,
          total: props.allEquipmentFeedback?.total_count,
          showSizeChanger: false,
        }}
        columns={columns}
        scroll={{ x: 800 }}
        rowKey="id"
        onChange={(e) => {
          setCurrentPage(e.current);
        }}
      />
    </div>
  );
}

export default Feedback;
